import { Ds } from "@accurx/design";
import { useCompose } from "domains/message-component/context";
import { ComposeActionsTypes } from "domains/message-component/reducer.types";

import { ScheduleSend } from "../ScheduleSend/ScheduleSend";
import { ScheduleSendAt } from "../ScheduleSend/types/ScheduleSend.types";
import { StyledLoadingButton } from "./SendSplitButton.styles";

type SendSplitButtonProps = {
    isSending: boolean;
    sendMessageHandler: () => void;
};

export const SendSplitButton = ({
    isSending,
    sendMessageHandler,
}: SendSplitButtonProps) => {
    const { state, dispatch } = useCompose();

    const onConfirmScheduleSend = (sendAt: ScheduleSendAt) => {
        dispatch({
            type: ComposeActionsTypes.UpdateSendAt,
            payload: { sendAt },
        });
    };

    return (
        <>
            {isSending ? (
                <StyledLoadingButton
                    aria-label="Send"
                    loading={true}
                    disabled={true}
                    size="small"
                >
                    {""}
                </StyledLoadingButton>
            ) : (
                <Ds.ButtonGroup>
                    <Ds.Button
                        disabled={state.isScheduling}
                        size="small"
                        onClick={sendMessageHandler}
                        data-testid="split-button-send-message"
                    >
                        <Ds.Icon
                            name={state.sendAt ? "Clock" : "Send"}
                            color="white"
                            size="small"
                            appearance={state.sendAt ? "outline" : "solid"}
                            aria-hidden={true}
                        />
                        <span>Send</span>
                    </Ds.Button>

                    <ScheduleSend
                        onConfirmScheduleSend={onConfirmScheduleSend}
                    />
                </Ds.ButtonGroup>
            )}
        </>
    );
};
